import type { RoleplayDebrief } from '@wundo/shared/roleplay.ts';
import { m } from '@/paraglide/messages.js';

/**
 * What one finished practice conversation's report is called.
 *
 * Both hosts read the same debrief and give it the same name, so the ending of
 * a conversation is titled by what it produced rather than by where it is being
 * read. A conversation nobody spoke in produced nothing, and "Jouw feedback"
 * over a paragraph explaining that there is none promises a report that will
 * never be written.
 */
export function practiceFeedbackTitle(debrief: RoleplayDebrief | null): string {
  return debrief === null
    ? m.practice_session_aborted_title()
    : m.practice_feedback_title();
}
